export default {
  reservation: {
    howToPay: {
      0: 'PayPay事前決済',
      1: 'オンライン決済',
    },
    cancelType: {
      0: '-',
      1: '当日',
      2: '前日',
    },
  },
  user: {
    status: {
      0: '仮登録（メール未認証）',
      1: '仮登録（メール認証済）',
      2: '本登録',
      99: '退会済み',
    },
    grade: {
      0: '無料会員',
      1: '有料会員',
    },
    gender: {
      0: '男性',
      1: '女性',
      2: '無回答'
    },
    genre: [
      'Animation',
      'Ballet',
      'Break',
      'Contemporary',
      'Diabolo',
      'FreeStyle',
      'FreeStyleBasketball',
      'FreeStyleFootball',
      'FreeStyleHustle',
      'Girls',
      'HipHop',
      'House',
      'Jazz',
      'JazzFunk',
      'JazzHipHop',
      'KPop',
      'Latin',
      'Lock',
      'Pantomime',
      'Pop',
      'Punking',
      'RB',
      'Salsa',
      'Soul',
      'Tap',
      'Tut',
      'Vogue',
      'Yoga',
      'Waack',
      'Others',
    ]
  },
  coupon: {
    discountTargetService: {
      park: 0,
      studio: 1,
    }
  }
};
